<script lang="ts">
  import { LOBBY_COPY, MISSION_TICKS, O2_CRITICAL, O2_LOW, RESERVE_CRITICAL, RESERVE_LOW, netDrainPerSecond, scramEtaTicks, ticksToClock } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";
  import { advisoryFor } from "../lib/advisory.js";

  const snap = $derived(ship.snap!);
  const eta = $derived(scramEtaTicks(snap.reserve, snap.drainMultiplier));
  const tone = $derived(snap.reserve <= RESERVE_CRITICAL ? "bad" : snap.reserve <= RESERVE_LOW ? "warn" : "");
  const o2tone = $derived(snap.o2 <= O2_CRITICAL ? "bad" : snap.o2 <= O2_LOW ? "warn" : "");
</script>

<div class="strip" role="group" aria-label="Ship status">
  {#if snap.phase === "lobby"}
    <span class="warn">{LOBBY_COPY.waiting}</span>
    <span>HULL CODE <strong class="code">{snap.hullCode}</strong></span>
  {:else}
    <span>T+{ticksToClock(snap.tick)} / {ticksToClock(MISSION_TICKS)}</span>
    <span class={tone}>RESERVE {snap.reserve.toFixed(1)} %</span>
    <span class={snap.drainMultiplier > 1 ? "warn" : ""}>NET −{netDrainPerSecond(snap.drainMultiplier).toFixed(2)} %/s</span>
    <span class={tone}>EST. SCRAM T−{ticksToClock(eta)}</span>
    <span class={o2tone}>O2 {snap.o2.toFixed(0)} %</span>
    {#if snap.relay.status === "damaged" || snap.relay.status === "carried"}<span class="bad">RELAY DOWN</span>{/if}
    {#if snap.activeEvent === "coolant"}<span class="warn">COOLANT LEAK</span>{/if}
  {/if}
  <span class="notice" aria-live="polite">{snap.notice}</span>
  {#if snap.phase === "running"}<span class="advisory dim">{advisoryFor(snap)}</span>{/if}
</div>

<style>
  .strip { display: flex; flex-wrap: wrap; gap: 0.4rem 1.4rem; border: 1px solid var(--fg-dim); padding: 0.5rem 0.8rem; }
  .notice { flex-basis: 100%; color: var(--warn); min-height: 1.4em; }
  .advisory { flex-basis: 100%; min-height: 1.4em; }
  .code { font-size: 1.5em; letter-spacing: 0.15em; color: var(--fg); user-select: all; }
</style>
